import { render, staticRenderFns } from "./OrgPicker2.vue?vue&type=template&id=200fb58f&scoped=true&"
import script from "./OrgPicker2.vue?vue&type=script&lang=js&"
export * from "./OrgPicker2.vue?vue&type=script&lang=js&"
import style0 from "./OrgPicker2.vue?vue&type=style&index=0&id=200fb58f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200fb58f",
  null
  
)

export default component.exports